import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FunctionalLoader } from 'seagull';
import { useServicesBillingDetails } from '~/hooks/reactQuery/queries/useServicesBillingDetails';
import { relationshipModel } from '~/models';
import { useCobConfigOptional } from '../CobConfigContext';
import { ReviewServicesV2 } from './ReviewServicesV2/ReviewServicesV2';
export function ReviewServices(props) {
    const { relationship, selectedBundleId, selectedOptionalServices, setSelectedOptionalServices } = props;
    const cobConfig = useCobConfigOptional();
    const entityContext = cobConfig === null || cobConfig === void 0 ? void 0 : cobConfig.entityContext;
    const effectiveDate = relationshipModel.effectiveDate(relationship);
    const [services, nonOptionalServices, optionalServices] = useMemo(()=>{
        const services = relationshipModel.actualServices(relationship, selectedBundleId);
        return [
            services,
            services.filter((s)=>s.participation.type === 'mandatory'),
            services.filter((s)=>s.participation.type === 'optional')
        ];
    }, [
        relationship,
        selectedBundleId
    ]);
    const { isLoading } = useServicesBillingDetails({
        services: services,
        relationshipEffectiveDate: effectiveDate
    });
    if (isLoading) {
        return /*#__PURE__*/ _jsx(FunctionalLoader, {
            name: 'fetchPriorPeriods',
            show: true
        });
    }
    return /*#__PURE__*/ _jsx(ReviewServicesV2, {
        services: services,
        nonOptionalServices: nonOptionalServices,
        optionalServices: optionalServices,
        relationship: relationship,
        selectedOptionalServices: selectedOptionalServices,
        selectedBundleId: selectedBundleId,
        setSelectedOptionalServices: setSelectedOptionalServices,
        entityContext: entityContext
    });
}
